import React, { useEffect } from 'react'
import { connect } from 'react-redux'
import { createSelector } from '@reduxjs/toolkit'
import { withRouterProps } from '../../utils/with-router-props'

import { apiResourceEndpoint, buildRoutePath, routes } from '../../../constants/routes'
import { fetchApiDataIfNeeded } from '../../../actions/api'
import { Link } from 'react-router-dom'
import { PaginationWrapper } from 'shs-pagination'
import moment from 'moment'

const selectTeamPaginator = state => state.paginator.teams
const selectTeams = state => state.teams
const makeTeams = createSelector(
    [selectTeams, selectTeamPaginator],
    (teams, paginator) => {
        if (paginator) {
            return teams
                .filter(field => paginator.itemIds.indexOf(field.id) !== -1)
                .sort((a, b) => {
                    if (paginator.itemIds.indexOf(a.id) > paginator.itemIds.indexOf(b.id)) {
                        return 1
                    }
                    return -1
                })
        }
        return []
    }
)

const mapStateToProps = (state, ownProps) => {
    const paginator = state.paginator.teams
    const teams = makeTeams(state)
    return { paginator, teams, roles: state.roles, account: state.account, user: state.user }
}

const TeamList = ({ dispatch, paginator, teams, roles, account, user }) => {
    const accountId = account.id
    useEffect(() => {
        dispatch(fetchApiDataIfNeeded(apiResourceEndpoint('teams', 'LIST')))
        dispatch(fetchApiDataIfNeeded(apiResourceEndpoint('roles', 'LIST')))
    }, [dispatch])

    const renderTeamRow = (team, index) => {
        const role = roles.find(r => r.id === team.roleId)
        return (
            // <div className="card" key={team.id}>
            //     <div className="index mobile-hide">{index}.</div>
            //     <div className="main">
            //         {user._computed.roleLevel > 100 ? (
            //             <Link to={buildRoutePath(routes.appTeamMemberView.path, { accountId, userId: team.id })}>
            //                 {team.firstName} {team.lastName}
            //             </Link>
            //         ) : (
            //             <span>{team.firstName} {team.lastName}</span>
            //         )}
            //     </div>
            //     <div className="main">{team.email}</div>
            //     <div className="main">{role?.name}</div>
            //     <div className="main mobile-hide">{moment(team.createdAt).format('MMM Do \'YY h:mm a')}</div>
            // </div>
            <tr key={team.id}>
                <td className="index mobile-hide">{index}.</td>
                <td className="main">
                    <span>{team.firstName} {team.lastName}</span>
                </td>
                <td className="main">{team.email}</td>
                <td className="main">{role?.name}</td>
                <td className="main mobile-hide">{moment(team.createdAt).format('MMM Do \'YY h:mm a')}</td>
                {user._computed.roleLevel > 100 && <td className="main mobile-hide">
                    <Link className="btn outline small" to={buildRoutePath(routes.appTeamMemberView.path, { accountId, userId: team.id })}>
                        View
                    </Link>
                </td>}
            </tr>
        )
    }

    const handlePaginationUpdate = (paginationParams) => {
        dispatch(fetchApiDataIfNeeded(apiResourceEndpoint(`teams`, 'LIST'), paginationParams))
    }

    const renderTeam = () => {
        if (!paginator) {
            return null
        }
        let allTeams = []
        teams?.forEach((team, idx) => {
            let index = idx + ((paginator.currentPage - 1) * paginator.perPage) + 1
            allTeams.push(renderTeamRow(team, index))
        })
        return (
            <PaginationWrapper
                paginator={paginator}
                controls={{ search: { enabled: true, collapsed: false } }}
                callbackFX={handlePaginationUpdate}>
                <table className="table">
                    <thead>
                        <tr>
                            <th className="mobile-hide">#</th>
                            <th>Name</th>
                            <th>Email</th>
                            <th>Role</th>
                            <th className="mobile-hide">Created</th>
                            {user._computed.roleLevel > 100 && <th>&nbsp;</th>}
                        </tr>
                    </thead>
                    <tbody>
                        {allTeams}
                    </tbody>
                </table>
                {/* <div className="card-grid">
                    {allTeams}
                </div> */}
            </PaginationWrapper>
        )
    }

    return (
        <div className="app-dashboard">
            <div className="header">
                <div className="container">
                    <div className="header-details">
                        <h1>{user.firstName} {user.lastName}'s Team</h1>
                    </div>
                    { user._computed.roleLevel > 100 &&
                        <div className="header-actions">
                            <Link to={buildRoutePath(routes.appCreateUser.path, { accountId })} className="btn blue main" key="add-item">
                                Create User
                            </Link>
                        </div>
                    }
                </div>
            </div>
            <div className="content-wrapper">
                <div className="container">
                    {renderTeam()}
                </div>
            </div>
        </div>
    )
}

export default withRouterProps(connect(mapStateToProps)(TeamList))
